(function() {

angular
    .module('meanApp')
    .factory('httpAuth', ['$http', 'authentication', 'loginModal',
    function ($http, auth, loginModal) {
        return {
            /**Make a call using the Bearer authenticationHeader**/
            _getAuthorizationHeader : function () {
                return 'Bearer '+ auth.getToken();
            },
            _onAuthFailure : function(json, errorCode) {
                //TODO check if this is a 401
                //console.log('on auth failure', arguments);
                if (errorCode === 401) {
                    loginModal.open(true);
                }
            },
            get : function(url) {
                return $http.get(url, {
                    headers : {
                        Authorization: this._getAuthorizationHeader()
                    }
                }).error(this._onAuthFailure);
            },
            put : function(url, formData, config) {
                var configMerged = config;

                if (!configMerged['headers']) {
                    configMerged['headers'] = {
                        Authorization: this._getAuthorizationHeader()
                    };
                }
                else {
                    configMerged['headers']['Authorization'] = this._getAuthorizationHeader();
                }
                
                return $http.put(url, formData, configMerged).error(this._onAuthFailure);
            },
            post : function(url, formData, config) {
                var configMerged = config;
                //add the header for auth without removing previous options passed away by JS.
                if (!configMerged['headers']) {
                    configMerged['headers'] = {
                        Authorization: this._getAuthorizationHeader()
                    };
                }
                else {
                    configMerged['headers']['Authorization'] = this._getAuthorizationHeader();
                }

                return $http.post(url, formData, configMerged).error(this._onAuthFailure);
            },
            delete : function(url) {
                return $http.delete(url, {
                    headers : {
                        Authorization: this._getAuthorizationHeader()
                    }
                }).error(this._onAuthFailure);
            }
        };
    }]);
})();